import { hasSessionReadyCookie } from './session-ready-cookie';

const SESSION_BOOTSTRAP_TIMEOUT_MS = 30_000;

let bootstrapRunner: (() => Promise<void>) | null = null;

/** 由 run-session-bootstrap 在模块加载时注册，避免与 fetch 循环依赖 */
export function registerSessionBootstrapRunner(runner: () => Promise<void>): void {
    bootstrapRunner = runner;
}

/**
 * waitForSession 为 true 时：有 session_ready cookie 则 0 等待；
 * 否则仅 await establishSession（register + postLogin），不等待 profile hydrate。
 */
export async function ensureSessionForRequest(waitForSession?: boolean): Promise<void> {
    if (!waitForSession) {
        return;
    }
    if (hasSessionReadyCookie()) {
        return;
    }
    if (!bootstrapRunner) {
        throw new Error('session_bootstrap_not_registered');
    }

    await Promise.race([
        bootstrapRunner(),
        new Promise<never>((_, reject) => {
            setTimeout(() => reject(new Error('session_bootstrap_timeout')), SESSION_BOOTSTRAP_TIMEOUT_MS);
        }),
    ]);
}
